/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2017
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'../VisSelectionInfo'
], function(
	VisSelectionInfo) {
	'use strict';

	var GridSelectionInfo = VisSelectionInfo.extend({
		init: function() {
			GridSelectionInfo.inherited('init', this, arguments);
			this._navigateActionSelections = null;
		},

		addNavigateActionSelection: function(oSlot, oDataItem, sValue) {

			if (!this._navigateActionSelection) {
				this._navigateActionSelections = [];
			}

			this._navigateActionSelections.push(this._createSelectionObject(oSlot, oDataItem, sValue));

		},

		_isEdgeSelection: function() {
			//returns true so that the filter selection will not be a compound filter.
			return true;
		},

		getNavigateActionSelections: function() {
			return this._navigateActionSelections;
		}
	});

	return GridSelectionInfo;
});
